import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiPath from '../../utils/apiPath';

const extractError = (err, rejectWithValue) => {
  if (err.response?.data) {
    return rejectWithValue(err.response.data.message || err.response.data);
  }
  return rejectWithValue(err.message || 'Something went wrong');
};

export const fetchInventoryAuditReport = createAsyncThunk(
  'inventoryAuditReport/fetch',
  async ({ start_date, end_date, warehouse_id, category, item_code, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const params = { page, limit };
      if (start_date) params.start_date = start_date;
      if (end_date) params.end_date = end_date;
      if (warehouse_id) params.warehouse_id = warehouse_id;
      if (category) params.category = category;
      if (item_code) params.item_code = item_code;

      const response = await apiPath.get('/api/v1.0/inventory-reports/audit', { params });
      return response.data;
    } catch (error) {
      return extractError(error, rejectWithValue);
    }
  }
);

const inventoryAuditReportSlice = createSlice({
  name: 'inventoryAuditReport',
  initialState: {
    rows: [],
    summary: null,
    filters: null,
    page: 1,
    limit: 10,
    totalRecord: 0,
    totalPage: 0,
    loading: false,
    error: null,
  },
  reducers: {
    clearInventoryAuditReportError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryAuditReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventoryAuditReport.fulfilled, (state, action) => {
        state.loading = false;
        state.rows = action.payload?.rows || [];
        state.summary = action.payload?.summary || null;
        state.filters = action.payload?.filters || null;
        state.page = action.payload?.page || 1;
        state.limit = action.payload?.limit || 10;
        state.totalRecord = action.payload?.totalRecord || 0;
        state.totalPage = action.payload?.totalPage || 0;
      })
      .addCase(fetchInventoryAuditReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
        state.rows = [];
        state.summary = null;
      });
  },
});

export const { clearInventoryAuditReportError } = inventoryAuditReportSlice.actions;
export default inventoryAuditReportSlice.reducer;